module.exports = __webpack_public_path__ + "static/media/shape_2.936b9d03.png";